import styled from 'styled-components';
import { useApiInfoContextValueHook } from '../../../../../contexts/ApiInfoContextProvider';
import { useEffect, useState } from 'react';
import { SellertoolSignatureUtils } from '../../../../../utils/sellertool-signature-utils';
import { CustomBackdropController } from '../../../../../components/backdrop/default/v1';
import axios from 'axios';
import { customToast } from '../../../../../components/toast/custom-react-toastify/v1';
import { CustomLabelInput } from '../../../../../components/input/CustomLabelInput';
import CustomBlockButton from '../../../../../components/button/CustomBlockButton';
import { CustomRatioImage } from '../../../../../components/image/CustomRatioImage';

const API_HOST = process.env.REACT_APP_MAIN_API_HOST;

const StyledSearchField = {
    Container: styled.div`
        margin-bottom: 20px;
    `,
    Wrapper: styled.div`
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        @media all and (max-width:992px){
            flex-direction: column;
            gap: 10px;
        }

        .box{
            display: flex;
            gap: 10px;
            align-items: center;
            flex:1;
            width: 100%;
        }

        .inputBox{
            position: relative;
            flex:1;
            /* max-width: 300px; */
            input{
            }

            .label{
                position: absolute;
                bottom: 2px;
                right: 10px;
                font-size: 10px;
                color: var(--purpleColor1);
                font-weight: 700;
                z-index: 1;
            }
        }

        button{
            width: 40px;
            height: 40px;
            background: #efefef;
            border: none;

            .iconFigure{
                width: 24px;
            }
        }
    `,
}

const LocationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 10px;
`;

// 로케이션 아이템 스타일
const LocationItem = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #f5f5f5;
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
`;

const RackNumber = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 8px;
`;

const InfoRow = styled.div`
  display: flex;
  margin-bottom: 4px;
`;

const InfoLabel = styled.span`
  font-weight: 500;
  width: 100px;
  color: #666;
`;

const InfoValue = styled.span`
  flex: 1;
  color: ${(props) => props.$color ? props.$color : '#333'};
`;

// 사용 가능 여부에 따른 스타일
const AvailabilityBadge = styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: ${(props) => (props.$enabled_yn === 'y' ? "var(--greenColor1-light)" : "var(--redColor2-light)")};
  color: ${(props) => (props.$enabled_yn === 'y' ? "var(--greenColor1)" : "var(--redColor2)")};
`

export function DestinationRackLocationsFragment({ originRackLocation, onSelectDestinationRackLocation }) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [destinationRackLocations, setDestinationRackLocations] = useState([]);
    const [addressSearchQueryDatas, setAddressSearchQueryDatas] = useState({
        rack: '',
        bay: '',
        level: '',
        position: ''
    });

    useEffect(() => {
        handleReqFetchRackLocations();
    }, [])

    const handleReqFetchRackLocations = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const fetchResult = await axios.get(`${API_HOST}/rack-locations`, {
            headers: headers
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            });

        if (fetchResult?.content) {
            setDestinationRackLocations(fetchResult?.content?.filter(r => r.uuid !== originRackLocation?.uuid));
        }

        CustomBackdropController().hideBackdrop();
    }

    const handleSetAddressSearchQueryDatas = (data) => {
        setAddressSearchQueryDatas(data);
    }

    const filteredRackLocations = destinationRackLocations?.filter(rackLocation => {
        const addressSplit = rackLocation.address.split('-');
        const centerNumber = addressSplit[0];
        const rackNumber = addressSplit[1];
        const bayNumber = addressSplit[2];
        const levelNumber = addressSplit[3];
        const positionNumber = addressSplit[4];

        if (
            rackNumber?.toLowerCase().includes(addressSearchQueryDatas?.rack.toLowerCase()) &&
            bayNumber?.toLowerCase().includes(addressSearchQueryDatas?.bay.toLowerCase()) &&
            levelNumber?.toLowerCase().includes(addressSearchQueryDatas?.level.toLowerCase()) &&
            positionNumber?.toLowerCase().includes(addressSearchQueryDatas?.position.toLowerCase())
        ) {
            return true;
        }
        return false;
    })?.sort((a, b) => {
        if (a.address < b.address) return -1;
        if (a.address > b.address) return 1;
        return 0;
    })

    return (
        <>
            <SearchField
                addressSearchQueryDatas={addressSearchQueryDatas}
                onSetAddressSearchQueryDatas={handleSetAddressSearchQueryDatas}
            />
            <LocationGrid>
                {filteredRackLocations.map((location, index) => (
                    <LocationItem
                        key={index}
                        onClick={() => onSelectDestinationRackLocation(location)}
                    >
                        <RackNumber>{location.address}</RackNumber>
                        <InfoRow>
                            <InfoLabel>타입:</InfoLabel>
                            <InfoValue $color={location.type === 'INVENTORY' ? 'var(--blueColor1)' : 'var(--greenColor1)'}>{location.type}</InfoValue>
                        </InfoRow>
                        <InfoRow>
                            <InfoLabel>사용가능여부:</InfoLabel>
                            <InfoValue>
                                <AvailabilityBadge $enabled_yn={location.enabledYn}>
                                    {location.enabledYn === 'y' ? "사용가능" : "사용불가"}
                                </AvailabilityBadge>
                            </InfoValue>
                        </InfoRow>
                        <InfoRow>
                            <InfoLabel>내부상품수량:</InfoLabel>
                            <InfoValue>{location.items?.length}개</InfoValue>
                        </InfoRow>
                    </LocationItem>
                ))}
            </LocationGrid>
        </>
    );
}

function SearchField({
    addressSearchQueryDatas,
    onSetAddressSearchQueryDatas
}) {
    const [addressSearchQuery, setAddressSearchQuery] = useState('');

    const handleSearch = (e) => {
        e.preventDefault();

        let firstSplit = addressSearchQuery?.split(' ');
        let center = '';
        let rack = '';
        let bay = '';
        let level = '';
        let position = '';

        if (firstSplit?.length === 1) {
            let secondSplit = firstSplit[0].split('-');

            if (secondSplit?.length === 4) {
                rack = (!secondSplit[0] || secondSplit[0] === '*') ? '' : secondSplit[0];
                bay = (!secondSplit[1] || secondSplit[1] === '*') ? '' : secondSplit[1];
                level = (!secondSplit[2] || secondSplit[2] === '*') ? '' : secondSplit[2];
                position = (!secondSplit[3] || secondSplit[3] === '*') ? '' : secondSplit[3];
            } else if (secondSplit?.length === 5) {
                rack = (!secondSplit[1] || secondSplit[1] === '*') ? '' : secondSplit[1];
                bay = (!secondSplit[2] || secondSplit[2] === '*') ? '' : secondSplit[2];
                level = (!secondSplit[3] || secondSplit[3] === '*') ? '' : secondSplit[3];
                position = (!secondSplit[4] || secondSplit[4] === '*') ? '' : secondSplit[4];
            }
        } else if (firstSplit?.length === 4) {
            rack = (!firstSplit[0] || firstSplit[0] === '*') ? '' : firstSplit[0];
            bay = (!firstSplit[1] || firstSplit[1] === '*') ? '' : firstSplit[1];
            level = (!firstSplit[2] || firstSplit[2] === '*') ? '' : firstSplit[2];
            position = (!firstSplit[3] || firstSplit[3] === '*') ? '' : firstSplit[3];
        } else if (firstSplit?.length === 5) {
            rack = (!firstSplit[1] || firstSplit[1] === '*') ? '' : firstSplit[1];
            bay = (!firstSplit[2] || firstSplit[2] === '*') ? '' : firstSplit[2];
            level = (!firstSplit[3] || firstSplit[3] === '*') ? '' : firstSplit[3];
            position = (!firstSplit[4] || firstSplit[4] === '*') ? '' : firstSplit[4];
        } else {
            rack = '';
            bay = '';
            level = '';
            position = '';
        }
        onSetAddressSearchQueryDatas({
            rack: rack.toUpperCase(),
            bay: bay.toUpperCase(),
            level: level.toUpperCase(),
            position: position.toUpperCase()
        });
    }

    const handleReset = () => {
        onSetAddressSearchQueryDatas({
            rack: '',
            bay: '',
            level: '',
            position: ''
        })
        setAddressSearchQuery('');
    }

    return (
        <StyledSearchField.Container>
            <form onSubmit={(e) => handleSearch(e)}>
                <StyledSearchField.Wrapper>
                    <div className='box'>
                        <div className='inputBox'>
                            <CustomLabelInput>
                                <CustomLabelInput.Input
                                    type='text'
                                    value={addressSearchQuery || ''}
                                    onChange={(e) => setAddressSearchQuery(e.target.value)}
                                ></CustomLabelInput.Input>
                                <CustomLabelInput.Label>[센터 랙 베이 레벨 포지션] 와일드카드(*)</CustomLabelInput.Label>
                            </CustomLabelInput>
                            <label className='label'>로케이션 : Z-{addressSearchQueryDatas?.rack || '*'}-{addressSearchQueryDatas?.bay || '*'}-{addressSearchQueryDatas?.level || '*'}-{addressSearchQueryDatas?.position || '*'}</label>
                        </div>
                    </div>
                    <CustomBlockButton
                        type='submit'
                    >
                        <div className='iconFigure'>
                            <CustomRatioImage.Figure width={1} height={1} className='figure'>
                                <CustomRatioImage.Image src={`/assets/icons/search_000000.svg`} />
                            </CustomRatioImage.Figure>
                        </div>
                    </CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        onClick={() => handleReset()}
                    >
                        <div className='iconFigure'>
                            <CustomRatioImage.Figure width={1} height={1} className='figure'>
                                <CustomRatioImage.Image src={`/assets/icons/refresh_000000.svg`} />
                            </CustomRatioImage.Figure>
                        </div>
                    </CustomBlockButton>
                </StyledSearchField.Wrapper>
            </form>
        </StyledSearchField.Container>
    );
}